import React from "react";
import { useSelector } from "react-redux";
import PropTypes from 'prop-types'
import { ButtonCommonTop } from "../../pages/Theme";

const ButtonCommon = ({ onClick, title, width, className, disabled, noCursor, textStyle, buttonStyle, bgColor, color }) => {
    return (
        <ButtonCommonTop className={`rounded-lg filter drop-shadow-md ${buttonStyle}`}>
            <button
                className={`flex flex-row rounded-lg items-center justify-center hover:opacity-80
                        w-${width} ${className} filter drop-shadow-md 
                        ${disabled ? `hidden` : `block`}
                        ${noCursor ? `cursor-nodrop` : ``}
                        `}
                onClick={(onClick)}
            >
                <p className={`font-semibold text-xs lg:text-sm ${textStyle}`}>{title}</p>
            </button>
        </ButtonCommonTop>
    )
}

ButtonCommon.propTypes = {
    title: PropTypes.string,
    onClick: PropTypes.func,
    width: PropTypes.string,
}

export default ButtonCommon;
